<template>
  <div class="cancelled-wrap">
    <div class="cancelled-card">
      <div class="cancelled-icon">&#9888;</div>
      <h1 class="cancelled-title">付款尚未完成</h1>
      <p class="cancelled-desc">
        你的訂單已成功建立，但 LINE Pay 付款流程未完成。<br>
        訂單不會自動取消，你可以前往訂單頁面查看狀態。
      </p>

      <div v-if="orderId" class="order-id-box">
        訂單編號：<strong>{{ orderId }}</strong>
      </div>

      <div class="cancelled-actions">
        <router-link
          v-if="orderId"
          :to="`/paymentSlip?MerTradeNo=${orderId}`"
          class="btn-primary"
        >
          查看訂單
        </router-link>
        <router-link to="/" class="btn-secondary">
          返回首頁
        </router-link>
      </div>

      <p class="cancelled-note">
        如有疑問，請聯絡客服，並提供訂單編號。
      </p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const orderId = computed(() => route.query.orderId || '')
</script>

<style scoped>
.cancelled-wrap {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #faf9f7;
  padding: 40px 16px;
}

.cancelled-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
  padding: 48px 40px;
  max-width: 480px;
  width: 100%;
  text-align: center;
}

.cancelled-icon {
  font-size: 3rem;
  color: #f59e0b;
  margin-bottom: 16px;
}

.cancelled-title {
  font-size: 1.5rem;
  color: #4a3728;
  margin: 0 0 16px;
  font-weight: 700;
}

.cancelled-desc {
  color: #666;
  font-size: 0.95rem;
  line-height: 1.7;
  margin: 0 0 24px;
}

.order-id-box {
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 0.95rem;
  color: #92400e;
  margin-bottom: 28px;
}

.cancelled-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
}

.btn-primary {
  background: #c8a96e;
  color: #fff;
  text-decoration: none;
  padding: 12px 28px;
  border-radius: 24px;
  font-size: 0.95rem;
  font-weight: 600;
  transition: background 0.2s;
}
.btn-primary:hover {
  background: #a8883e;
}

.btn-secondary {
  background: #f3f3f3;
  color: #555;
  text-decoration: none;
  padding: 12px 28px;
  border-radius: 24px;
  font-size: 0.95rem;
  transition: background 0.2s;
}
.btn-secondary:hover {
  background: #e0e0e0;
}

.cancelled-note {
  color: #aaa;
  font-size: 0.8rem;
  margin: 0;
}

@media (max-width: 480px) {
  .cancelled-card {
    padding: 36px 24px;
  }
}
</style>
